import { SxProps, Theme } from '@mui/material/styles';

export function withSxProp(sx?: SxProps<Theme>) {
    return Array.isArray(sx) ? sx : [sx];
}
